import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getQaGroupsThunk, getQaGroupDetailsThunk, deleteQaGroupAgentThunk, getFreeAgentsThunk, applyGroupAutomationThunk, createQaGroupThunk, getQaGroupHeadsThunk, addAgentToGroupThunk, updateQaGroupThunk, deleteQaGroupThunk } from '../../../redux/qa/qaActions';
import { selectAccessToken, selectSwitcher, selectUserType } from '../../../redux/selectors';
import { Notify } from 'notiflix';
import { useLocation, useNavigate } from 'react-router-dom';
import { setQaFilter } from '../../../redux/qa/qaSlice';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  AreaChart,
  Area,
} from 'recharts';
import {
  Container,
  Header,
  Title,
  BlocksContainer,
  Controls,
  ControlsLeft,
  ControlsRight,
  SelectContainer,
  Label,
  Select,
  Button,
  CreateButton,
  GroupsContainer,
  GroupCard,
  GroupName,
  GroupInfo,
  GroupStat,
  StatValue,
  StatLabel,
  LoadingContainer,
  LoadingText,
  ErrorContainer,
  ErrorText,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody,
  GroupDetailsContainer,
  DetailSection,
  DetailTitle,
  DetailGrid,
  DetailItem,
  DetailValue,
  DetailLabel,
  AddAgentsButton,
  SecondModalOverlay,
  SecondModalContent,
  SearchSection,
  SearchTitle,
  SearchForm,
  SearchInput,
  SearchButton,
  AgentsListSection,
  AgentItem,
  AgentInfo,
  AgentName,
  AgentLcid,
  AddAgentButton,
  AutomationSection,
  AutomationTitle,
  AutomationContent,
  FlagContainer,
  FlagLabel,
  FlagCheckbox,
  ApplyAutomationButton,
  CreateGroupForm,
  FormRow,
  FormField,
  FormLabel,
  FormInput,
  FormTextarea,
  FormActions,
  CancelButton,
  SubmitButton,
  EmptyStateContainer,
  DailyStatisticsGrid,
  DailyStatCard,
  DayNumber,
  CheckedChats,
} from './QaGroup.styled';

const QaGroup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accessToken = useSelector(selectAccessToken);
  const switcher = useSelector(selectSwitcher);
  const userType = useSelector(selectUserType);
  const groups = useSelector(state => state.qa.groups);
  const freeAgents = useSelector(state => state.qa.freeAgents);
  const groupHeads = useSelector(state => state.qa.groupHeads);
  const groupDetails = useSelector(state => state.qa.groupDetails);
  const loading = useSelector(state => state.qa.loading);
  const error = useSelector(state => state.qa.error);
  const createGroupError = useSelector(state => state.qa.createGroupError);
  const location = useLocation();

  // Состояние для параметров запроса
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Текущий месяц
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Текущий год
  
  // Состояние для модального окна
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [isAddAgentsModalOpen, setIsAddAgentsModalOpen] = useState(false);
  const [searchLcid, setSearchLcid] = useState('');
  const [searchName, setSearchName] = useState('');
  const [searchYearMonth, setSearchYearMonth] = useState('');
  const [forceFlag, setForceFlag] = useState(false);
  const [missingFlag, setMissingFlag] = useState(false);
  const [isCreateGroupModalOpen, setIsCreateGroupModalOpen] = useState(false);
  const [isEditGroupModalOpen, setIsEditGroupModalOpen] = useState(false);
  const [newGroupData, setNewGroupData] = useState({
    name: '',
    head: 0,
    year: 2025,
    month: 7,
    comment: '',
    agents: []
  });
  const [editGroupData, setEditGroupData] = useState({
    name: '',
    head: 0,
    year: 2025,
    month: 7,
    comment: '',
    agents: []
  });

  // Опции для селекторов

  const monthOptions = [
    { value: 1, label: 'Январь' },
    { value: 2, label: 'Февраль' },
    { value: 3, label: 'Март' },
    { value: 4, label: 'Апрель' },
    { value: 5, label: 'Май' },
    { value: 6, label: 'Июнь' },
    { value: 7, label: 'Июль' },
    { value: 8, label: 'Август' },
    { value: 9, label: 'Сентябрь' },
    { value: 10, label: 'Октябрь' },
    { value: 11, label: 'Ноябрь' },
    { value: 12, label: 'Декабрь' },
  ];

  const yearOptions = [
    { value: 2024, label: '2024' },
    { value: 2025, label: '2025' },
    { value: 2026, label: '2026' },
  ];

  // Функция для загрузки групп
  const fetchGroups = async () => {
    try {
      await dispatch(getQaGroupsThunk({
        token: accessToken,
        month: selectedMonth,
        year: selectedYear,
      }));
    } catch (error) {
      Notify.failure('Ошибка при загрузке групп');
    }
  };

  // Загружаем группы при изменении параметров
  useEffect(() => {
    if (accessToken && location.pathname === '/QaGroup') {
      fetchGroups();
    }
  }, [accessToken, selectedMonth, selectedYear, location.pathname]);

  // Обновляем ID руководителя в форме редактирования после загрузки списка руководителей
  useEffect(() => {
    if (isEditGroupModalOpen && groupDetails && groupHeads && Array.isArray(groupHeads)) {
      console.log('Обновляем ID руководителя в форме редактирования');
      console.log('groupDetails.head:', groupDetails.head);
      console.log('groupHeads:', groupHeads);
      
      // Определяем правильный ID руководителя
      let headId = 0;
      if (groupDetails.head) {
        // Если head это объект с id
        if (typeof groupDetails.head === 'object' && groupDetails.head.id) {
          headId = groupDetails.head.id;
        }
        // Если head это число (ID)
        else if (typeof groupDetails.head === 'number') {
          headId = groupDetails.head;
        }
        // Если head это строка с числом
        else if (typeof groupDetails.head === 'string' && !isNaN(parseInt(groupDetails.head))) {
          headId = parseInt(groupDetails.head);
        }
        // Если head это строка (username) - ищем по username в списке руководителей
        else if (typeof groupDetails.head === 'string') {
          const foundHead = groupHeads.find(head => head.username === groupDetails.head);
          if (foundHead) {
            headId = foundHead.id;
            console.log('Найден руководитель по username:', foundHead);
          } else {
            console.log('Руководитель с username', groupDetails.head, 'не найден в списке');
          }
        }
      }
      
      console.log('Обновленный ID руководителя:', headId);
      
      // Обновляем данные формы
      setEditGroupData(prev => ({
        ...prev,
        head: headId
      }));
    }
  }, [isEditGroupModalOpen, groupDetails, groupHeads]);

  const handleMonthChange = (e) => {
    setSelectedMonth(parseInt(e.target.value));
  };

  const handleYearChange = (e) => {
    setSelectedYear(parseInt(e.target.value));
  };

  // Обработчик обновления данных
  const handleRefresh = () => {
    fetchGroups();
  };

  // Обработчик клика по группе
  const handleGroupClick = async (groupId) => {
    try {
      setSelectedGroupId(groupId);
      setIsModalOpen(true);
      await dispatch(getQaGroupDetailsThunk({ token: accessToken, groupId }));
    } catch (error) {
      Notify.failure('Ошибка при загрузке деталей группы');
    }
  };

  // Обработчик закрытия модального окна
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedGroupId(null);
  };

  const handleDeleteAgent = async (agentId) => {
    try {
      await dispatch(deleteQaGroupAgentThunk({
        token: accessToken,
        groupId: selectedGroupId,
        agentId: agentId
      })).unwrap();
      
      Notify.success('Агент успешно удален из группы');
    } catch (error) {
      console.error('Ошибка при удалении агента:', error);
      Notify.failure('Ошибка при удалении агента');
    }
  };

  const handleAddAgents = () => {
    setIsAddAgentsModalOpen(true);
    // Загружаем свободных агентов при открытии модального окна
    fetchFreeAgents();
  };

  const handleCloseAddAgentsModal = () => {
    setIsAddAgentsModalOpen(false);
    setSearchLcid('');
    setSearchName('');
    setSearchYearMonth('');
  };

  const fetchFreeAgents = async () => {
    try {
      await dispatch(getFreeAgentsThunk({
        token: accessToken,
        freeAgent: true,
        lcid: searchLcid,
        name: searchName,
        yearMonth: searchYearMonth
      }));
    } catch (error) {
      Notify.failure('Ошибка при загрузке свободных агентов');
    }
  };

  const handleSearchAgents = () => {
    fetchFreeAgents();
  };

  const handleAddAgentToGroup = async (agentId) => {
    try {
      await dispatch(addAgentToGroupThunk({
        token: accessToken,
        groupId: selectedGroupId,
        agentId: agentId
      })).unwrap();
      
      Notify.success('Агент успешно добавлен в группу');
      
      // Обновляем детали группы после добавления агента
      await dispatch(getQaGroupDetailsThunk({ 
        token: accessToken, 
        groupId: selectedGroupId 
      }));
      
      // Обновляем список групп
      fetchGroups();
      
      // Обновляем список свободных агентов
      await dispatch(getFreeAgentsThunk({
        token: accessToken,
        freeAgent: true,
        lcid: searchLcid,
        name: searchName,
        yearMonth: searchYearMonth
      }));
      
    } catch (error) {
      console.error('Ошибка при добавлении агента:', error);
      Notify.failure('Ошибка при добавлении агента в группу');
    }
  };

  const handleApplyAutomation = async () => {
    try {
      await dispatch(applyGroupAutomationThunk({
        token: accessToken,
        force: forceFlag,
        missing: missingFlag
      })).unwrap();
      
      Notify.success('Автоматизация успешно применена');
    } catch (error) {
      console.error('Ошибка при применении автоматизации:', error);
      Notify.failure('Ошибка при применении автоматизации');
    }
  };

  const handleOpenCreateGroupModal = async () => {
    setIsCreateGroupModalOpen(true);
    try {
      await dispatch(getQaGroupHeadsThunk({ token: accessToken, freeHead: true }));
    } catch (error) {
      Notify.failure('Ошибка при загрузке списка руководителей');
    }
  };

  const handleCloseCreateGroupModal = () => {
    setIsCreateGroupModalOpen(false);
    setNewGroupData({
      name: '',
      head: 0,
      year: 2025,
      month: 7,
      comment: '',
      agents: []
    });
  };

  const handleCreateGroup = async () => {
    try {
      await dispatch(createQaGroupThunk({
        token: accessToken,
        groupData: newGroupData
      })).unwrap();
      
      Notify.success('Группа успешно создана');
      handleCloseCreateGroupModal();
      fetchGroups(); // Обновляем список групп только при успешном создании
    } catch (error) {
      console.error('Ошибка при создании группы:', error);
      console.error('Тип ошибки:', typeof error);
      console.error('Содержимое ошибки:', JSON.stringify(error, null, 2));
      
      // Показываем более информативное сообщение об ошибке
      let errorMessage = 'Ошибка при создании группы';
      
      if (error && typeof error === 'string') {
        errorMessage = error;
      } else if (error && error.message) {
        errorMessage = error.message;
      } else if (error && error.response && error.response.data) {
        // Если есть данные от сервера
        if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        } else if (error.response.data.detail) {
          errorMessage = error.response.data.detail;
        }
      }
      
      Notify.failure(errorMessage);
      // Не обновляем список групп при ошибке
    }
  };

  const handleInputChange = (field, value) => {
    setNewGroupData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleEditInputChange = (field, value) => {
    setEditGroupData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleOpenEditGroupModal = async () => {
    if (groupDetails) {
      // Сначала загружаем список руководителей
      try {
        await dispatch(getQaGroupHeadsThunk({ token: accessToken, freeHead: true }));
        
        console.log('Детали группы для редактирования:', groupDetails);
        console.log('Список руководителей:', groupHeads);
        
        // Открываем модальное окно сразу
        setIsEditGroupModalOpen(true);
        
        // Устанавливаем базовые данные
        setEditGroupData({
          name: groupDetails.name || '',
          head: 0, // Временно устанавливаем 0
          year: groupDetails.year || 2025,
          month: groupDetails.month || 7,
          comment: groupDetails.comment || '',
          agents: groupDetails.agents || []
        });
        
      } catch (error) {
        Notify.failure('Ошибка при загрузке списка руководителей');
      }
    }
  };

  const handleCloseEditGroupModal = () => {
    setIsEditGroupModalOpen(false);
    setEditGroupData({
      name: '',
      head: 0,
      year: 2025,
      month: 7,
      comment: '',
      agents: []
    });
  };

  const handleEditGroup = async () => {
    try {
      // Подготавливаем данные для отправки, включая только измененные параметры
      const updateData = {};
      
      // Проверяем каждый параметр и добавляем только измененные
      if (editGroupData.name !== groupDetails.name) {
        updateData.name = editGroupData.name;
      }
      
      // Определяем текущий ID руководителя из groupDetails
      let currentHeadId = 0;
      if (groupDetails.head) {
        // Если head это объект с id
        if (typeof groupDetails.head === 'object' && groupDetails.head.id) {
          currentHeadId = groupDetails.head.id;
        }
        // Если head это число (ID)
        else if (typeof groupDetails.head === 'number') {
          currentHeadId = groupDetails.head;
        }
        // Если head это строка с числом
        else if (typeof groupDetails.head === 'string' && !isNaN(parseInt(groupDetails.head))) {
          currentHeadId = parseInt(groupDetails.head);
        }
        // Если head это строка (username) - ищем по username в списке руководителей
        else if (typeof groupDetails.head === 'string' && groupHeads && Array.isArray(groupHeads)) {
          const foundHead = groupHeads.find(head => head.username === groupDetails.head);
          if (foundHead) {
            currentHeadId = foundHead.id;
          }
        }
      }
      
      console.log('Текущий ID руководителя:', currentHeadId);
      console.log('Новый ID руководителя:', editGroupData.head);
      
      if (editGroupData.head !== currentHeadId) {
        updateData.head = editGroupData.head;
      }
      
      if (editGroupData.year !== groupDetails.year) {
        updateData.year = editGroupData.year;
      }
      
      if (editGroupData.month !== groupDetails.month) {
        updateData.month = editGroupData.month;
      }
      
      if (editGroupData.comment !== groupDetails.comment) {
        updateData.comment = editGroupData.comment;
      }
      
      // Проверяем агентов - сравниваем ID агентов
      const currentAgentIds = groupDetails.agents ? groupDetails.agents.map(agent => agent.id) : [];
      const newAgentIds = editGroupData.agents || [];
      
      if (JSON.stringify(currentAgentIds.sort()) !== JSON.stringify(newAgentIds.sort())) {
        updateData.agents = newAgentIds;
      }

      console.log('Исходные данные группы:', groupDetails);
      console.log('Данные формы:', editGroupData);
      console.log('Отправляем только измененные данные:', updateData);
      
      // Проверяем, есть ли изменения
      if (Object.keys(updateData).length === 0) {
        Notify.info('Нет изменений для сохранения');
        handleCloseEditGroupModal();
        return;
      }
      
      await dispatch(updateQaGroupThunk({
        token: accessToken,
        groupId: selectedGroupId,
        groupData: updateData
      })).unwrap();
      
      Notify.success('Группа успешно обновлена');
      handleCloseEditGroupModal();
      
      // Обновляем детали группы
      await dispatch(getQaGroupDetailsThunk({ 
        token: accessToken, 
        groupId: selectedGroupId 
      }));
      
      // Обновляем список групп
      fetchGroups();
      
    } catch (error) {
      console.error('Ошибка при обновлении группы:', error);
      
      // Показываем более информативное сообщение об ошибке
      let errorMessage = 'Ошибка при обновлении группы';
      
      if (error && typeof error === 'string') {
        errorMessage = error;
      } else if (error && error.message) {
        errorMessage = error.message;
      } else if (error && error.response && error.response.data) {
        if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        } else if (error.response.data.detail) {
          errorMessage = error.response.data.detail;
        }
      }
      
      Notify.failure(errorMessage);
    }
  };

  const handleDeleteGroup = async () => {
    try {
      // Показываем подтверждение удаления
      if (!window.confirm(`Вы уверены, что хотите удалить группу "${groupDetails?.name}"? Это действие нельзя отменить.`)) {
        return;
      }
      
      await dispatch(deleteQaGroupThunk({
        token: accessToken,
        groupId: selectedGroupId
      })).unwrap();
      
      Notify.success('Группа успешно удалена');
      handleCloseEditGroupModal();
      handleCloseModal(); // Закрываем модальное окно с деталями группы
      
      // Обновляем список групп
      fetchGroups();
      
    } catch (error) {
      console.error('Ошибка при удалении группы:', error);
      
      // Показываем более информативное сообщение об ошибке
      let errorMessage = 'Ошибка при удалении группы';
      
      if (error && typeof error === 'string') {
        errorMessage = error;
      } else if (error && error.message) {
        errorMessage = error.message;
      } else if (error && error.response && error.response.data) {
        if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        } else if (error.response.data.detail) {
          errorMessage = error.response.data.detail;
        }
      }
      
      Notify.failure(errorMessage);
    }
  };

  // Обновляем обработчик для перехода на страницу QA
  const handleNavigateToQa = (groupId) => {
    // Находим название группы
    const group = groups.find(g => g.id === groupId);
    const groupName = group ? group.name : 'Неизвестная группа';
    
    // Устанавливаем фильтр группы в Redux
    dispatch(setQaFilter({ group: groupId, groupName: groupName }));
    // Переходим на страницу QA
    navigate('/qa');
  };

  // Компонент для отображения пустого состояния
  const EmptyState = () => (
    <EmptyStateContainer switcher={switcher}>
      Группы не найдены для выбранного периода
    </EmptyStateContainer>
  );

  return (
    <Container>
      <Header>
        <Title switcher={switcher}>Статистика групп QA</Title>
        
        <BlocksContainer>
          {/* Блок автоматизации - только для head и tl */}
          {(userType === 'head' || userType === 'tl') && (
        <AutomationSection switcher={switcher}>
          <AutomationTitle switcher={switcher}>Автоматизация</AutomationTitle>
          <AutomationContent>
            <FlagContainer>
              <FlagLabel switcher={switcher}>
                <FlagCheckbox
                  type="checkbox"
                  checked={forceFlag}
                  onChange={(e) => setForceFlag(e.target.checked)}
                />
                Force
              </FlagLabel>
            </FlagContainer>
            <FlagContainer>
              <FlagLabel switcher={switcher}>
                <FlagCheckbox
                  type="checkbox"
                  checked={missingFlag}
                  onChange={(e) => setMissingFlag(e.target.checked)}
                />
                Missing
              </FlagLabel>
            </FlagContainer>
            <ApplyAutomationButton onClick={handleApplyAutomation} disabled={loading}>
              Применить
            </ApplyAutomationButton>
          </AutomationContent>
        </AutomationSection>
          )}

        <Controls switcher={switcher}>
          <ControlsLeft>
            <SelectContainer>
              <Label switcher={switcher}>Месяц:</Label>
              <Select value={selectedMonth} onChange={handleMonthChange} switcher={switcher} disabled={loading}>
                {monthOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            </SelectContainer>

            <SelectContainer>
              <Label switcher={switcher}>Год:</Label>
              <Select value={selectedYear} onChange={handleYearChange} switcher={switcher} disabled={loading}>
                {yearOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            </SelectContainer>
          </ControlsLeft>

          <ControlsRight>
            <Button onClick={handleRefresh} disabled={loading}>
              Обновить
            </Button>
              {/* Кнопка создания группы - только для head и tl */}
              {(userType === 'head' || userType === 'tl') && (
            <CreateButton onClick={handleOpenCreateGroupModal} disabled={loading}>
              Создать группу
            </CreateButton>
              )}
          </ControlsRight>
        </Controls>
        </BlocksContainer>
      </Header>

      {loading && (
        <LoadingContainer>
          <LoadingText switcher={switcher}>Загрузка групп...</LoadingText>
        </LoadingContainer>
      )}

      {error && !createGroupError && (
        <ErrorContainer switcher={switcher}>
          <ErrorText switcher={switcher}>
            {error === 'Rejected' ? 'Нет данных для отображения' : `Ошибка: ${error}`}
          </ErrorText>
        </ErrorContainer>
      )}

      {!loading && !error && groups && (
        Array.isArray(groups) && groups.length > 0 ? (
        <GroupsContainer>
            {groups.map((group, index) => (
              <GroupCard 
                key={group.id || index} 
                switcher={switcher}
                onClick={() => handleGroupClick(group.id)}
              >
                <GroupName switcher={switcher}>{group.name}</GroupName>
                <GroupInfo>
                  <GroupStat switcher={switcher}>
                    <StatValue>{group.statistics?.total_agents || 0}</StatValue>
                    <StatLabel switcher={switcher}>Агентов</StatLabel>
                  </GroupStat>
                  <GroupStat switcher={switcher}>
                    <StatValue>{group.statistics?.total_chats || 0}</StatValue>
                    <StatLabel switcher={switcher}>Чатов</StatLabel>
                  </GroupStat>
                  <GroupStat switcher={switcher}>
                    <StatValue>{group.statistics?.total_checked || 0}</StatValue>
                    <StatLabel switcher={switcher}>Проверено</StatLabel>
                  </GroupStat>
                  <GroupStat switcher={switcher}>
                    <StatValue>{group.statistics?.total_message_count || 0}</StatValue>
                    <StatLabel switcher={switcher}>Сообщений</StatLabel>
                  </GroupStat>
                </GroupInfo>
              </GroupCard>
            ))}
        </GroupsContainer>
        ) : (
          <EmptyState />
        )
      )}

      {/* Показываем список групп даже при ошибке создания группы */}
      {!loading && error && createGroupError && groups && (
        Array.isArray(groups) && groups.length > 0 ? (
        <GroupsContainer>
            {groups.map((group, index) => (
              <GroupCard 
                key={group.id || index} 
                switcher={switcher}
                onClick={() => handleGroupClick(group.id)}
              >
                <GroupName switcher={switcher}>{group.name}</GroupName>
                <GroupInfo>
                  <GroupStat switcher={switcher}>
                    <StatValue>{group.statistics?.total_agents || 0}</StatValue>
                    <StatLabel switcher={switcher}>Агентов</StatLabel>
                  </GroupStat>
                  <GroupStat switcher={switcher}>
                    <StatValue>{group.statistics?.total_chats || 0}</StatValue>
                    <StatLabel switcher={switcher}>Чатов</StatLabel>
                  </GroupStat>
                  <GroupStat switcher={switcher}>
                    <StatValue>{group.statistics?.total_checked || 0}</StatValue>
                    <StatLabel switcher={switcher}>Проверено</StatLabel>
                  </GroupStat>
                  <GroupStat switcher={switcher}>
                    <StatValue>{group.statistics?.total_message_count || 0}</StatValue>
                    <StatLabel switcher={switcher}>Сообщений</StatLabel>
                  </GroupStat>
                </GroupInfo>
              </GroupCard>
            ))}
        </GroupsContainer>
        ) : (
          <EmptyState />
        )
      )}

      {/* Модальное окно с деталями группы */}
      {isModalOpen && (
        <ModalOverlay onClick={handleCloseModal}>
          <ModalContent switcher={switcher} onClick={(e) => e.stopPropagation()}>
            <ModalHeader switcher={switcher}>
              <ModalTitle switcher={switcher}>
                {groupDetails?.name || `Группа ${selectedGroupId}`}
              </ModalTitle>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                {/* Кнопка перехода на страницу QA */}
                <Button 
                  onClick={() => handleNavigateToQa(selectedGroupId)}
                  style={{ 
                    padding: '6px 12px', 
                    fontSize: '12px',
                    background: switcher ? '#10b981' : '#10b981',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = switcher ? '#059669' : '#059669';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = switcher ? '#10b981' : '#10b981';
                  }}
                >
                  Просмотр чатов
                </Button>
                {/* Кнопка изменения - только для head и tl */}
                {(userType === 'head' || userType === 'tl') && (
                <Button 
                  onClick={handleOpenEditGroupModal}
                  style={{ 
                    padding: '6px 12px', 
                    fontSize: '12px',
                    background: switcher ? '#3b82f6' : '#3b82f6',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = switcher ? '#2563eb' : '#2563eb';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = switcher ? '#3b82f6' : '#3b82f6';
                  }}
                >
                  Изменить
                </Button>
                )}
                <CloseButton switcher={switcher} onClick={handleCloseModal}>
                  ✕
                </CloseButton>
              </div>
            </ModalHeader>
            
            <ModalBody switcher={switcher}>
              {loading ? (
                <LoadingContainer>
                  <LoadingText switcher={switcher}>Загрузка деталей группы...</LoadingText>
                </LoadingContainer>
              ) : groupDetails ? (
                <GroupDetailsContainer>
                  <DetailSection switcher={switcher}>
                    <DetailTitle switcher={switcher}>Информация о группе</DetailTitle>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '24px',
                      padding: '16px',
                      background: switcher ? '#374151' : '#f9fafb',
                      borderRadius: '8px',
                      border: `1px solid ${switcher ? '#4b5563' : '#e5e7eb'}`,
                      overflowX: 'auto'
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        minWidth: 'fit-content'
                      }}>
                        <span style={{ 
                          color: switcher ? '#9ca3af' : '#6b7280',
                          fontSize: '14px',
                          whiteSpace: 'nowrap'
                        }}>
                          ID группы:
                        </span>
                        <span style={{ 
                          color: switcher ? '#e5e7eb' : '#111827',
                          fontWeight: '600',
                          fontSize: '14px'
                        }}>
                          {groupDetails.id}
                        </span>
                      </div>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        minWidth: 'fit-content'
                      }}>
                        <span style={{ 
                          color: switcher ? '#9ca3af' : '#6b7280',
                          fontSize: '14px',
                          whiteSpace: 'nowrap'
                        }}>
                          Руководитель:
                        </span>
                        <span style={{ 
                          color: switcher ? '#e5e7eb' : '#111827',
                          fontWeight: '600',
                          fontSize: '14px'
                        }}>
                          {groupDetails.head_username || groupDetails.head || 'Не указан'}
                        </span>
                      </div>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        minWidth: 'fit-content'
                      }}>
                        <span style={{ 
                          color: switcher ? '#9ca3af' : '#6b7280',
                          fontSize: '14px',
                          whiteSpace: 'nowrap'
                        }}>
                          Период:
                        </span>
                        <span style={{ 
                          color: switcher ? '#e5e7eb' : '#111827',
                          fontWeight: '600',
                          fontSize: '14px'
                        }}>
                          {groupDetails.month}/{groupDetails.year}
                        </span>
                      </div>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        minWidth: 'fit-content'
                      }}>
                        <span style={{ 
                          color: switcher ? '#9ca3af' : '#6b7280',
                          fontSize: '14px',
                          whiteSpace: 'nowrap'
                        }}>
                          Агентов:
                        </span>
                        <span style={{ 
                          color: switcher ? '#e5e7eb' : '#111827',
                          fontWeight: '600',
                          fontSize: '14px'
                        }}>
                          {groupDetails.statistics?.total_agents || 0}
                        </span>
                      </div>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        minWidth: 'fit-content'
                      }}>
                        <span style={{ 
                          color: switcher ? '#9ca3af' : '#6b7280',
                          fontSize: '14px',
                          whiteSpace: 'nowrap'
                        }}>
                          Чатов:
                        </span>
                        <span style={{ 
                          color: switcher ? '#e5e7eb' : '#111827',
                          fontWeight: '600',
                          fontSize: '14px'
                        }}>
                          {groupDetails.statistics?.total_chats || 0}
                        </span>
                      </div>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        minWidth: 'fit-content'
                      }}>
                        <span style={{ 
                          color: switcher ? '#9ca3af' : '#6b7280',
                          fontSize: '14px',
                          whiteSpace: 'nowrap'
                        }}>
                          Проверено:
                        </span>
                        <span style={{ 
                          color: switcher ? '#e5e7eb' : '#111827',
                          fontWeight: '600',
                          fontSize: '14px'
                        }}>
                          {groupDetails.statistics?.total_checked || 0}
                        </span>
                      </div>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        minWidth: 'fit-content'
                      }}>
                        <span style={{ 
                          color: switcher ? '#9ca3af' : '#6b7280',
                          fontSize: '14px',
                          whiteSpace: 'nowrap'
                        }}>
                          Сообщений:
                        </span>
                        <span style={{ 
                          color: switcher ? '#e5e7eb' : '#111827',
                          fontWeight: '600',
                          fontSize: '14px'
                        }}>
                          {groupDetails.statistics?.total_message_count || 0}
                        </span>
                      </div>
                    </div>
                  </DetailSection>

                  {groupDetails.agents && Array.isArray(groupDetails.agents) && (
                    <DetailSection switcher={switcher}>
                      <DetailTitle switcher={switcher}>Агенты группы ({groupDetails.agents.length})</DetailTitle>
                      <div style={{ 
                        display: 'grid', 
                        gap: '8px',
                        maxHeight: '300px',
                        overflowY: 'auto',
                        padding: '8px',
                        background: switcher ? '#2d2d2d' : '#f9fafb',
                        borderRadius: '6px'
                      }}>
                        {groupDetails.agents.map((agent, index) => (
                          <div 
                            key={agent.id}
                            style={{
                              padding: '12px',
                              background: switcher ? '#404040' : '#ffffff',
                              border: `1px solid ${switcher ? '#525252' : '#e5e7eb'}`,
                              borderRadius: '6px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}
                          >
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                              <span style={{ 
                                color: switcher ? '#ffffff' : '#111827',
                                fontWeight: '600',
                                fontSize: '14px'
                              }}>
                                {agent.name}
                              </span>
                              <span style={{ 
                                color: switcher ? '#9ca3af' : '#6b7280',
                                fontSize: '12px'
                              }}>
                                {agent.lcid}
                              </span>
                            </div>
                            {/* Кнопка удаления агента - только для head и tl */}
                            {(userType === 'head' || userType === 'tl') && (
                            <span style={{ 
                              color: '#ef4444',
                              fontSize: '16px',
                              fontWeight: '600',
                              cursor: 'pointer',
                              padding: '4px',
                              borderRadius: '4px',
                              transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = switcher ? '#525252' : '#f3f4f6';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = 'transparent';
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteAgent(agent.id);
                            }}>
                              ✕
                            </span>
                            )}
                          </div>
                        ))}
                      </div>
                      {/* Кнопка добавления агентов - только для head и tl */}
                      {(userType === 'head' || userType === 'tl') && (
                      <AddAgentsButton onClick={handleAddAgents}>
                        + Добавить агентов
                      </AddAgentsButton>
                      )}
                    </DetailSection>
                  )}

                  {groupDetails.comment && (
                    <DetailSection switcher={switcher}>
                      <DetailTitle switcher={switcher}>Комментарий</DetailTitle>
                      <div style={{
                        padding: '12px',
                        background: switcher ? '#404040' : '#ffffff',
                        border: `1px solid ${switcher ? '#525252' : '#e5e7eb'}`,
                        borderRadius: '6px',
                        color: switcher ? '#d1d5db' : '#6b7280'
                      }}>
                        {groupDetails.comment}
                      </div>
                    </DetailSection>
                  )}

                  {/* Секция ежедневной статистики */}
                  {groupDetails.daily_statistics && groupDetails.daily_statistics.length > 0 && (
                    <DetailSection switcher={switcher}>
                      <DetailTitle switcher={switcher}>Ежедневная статистика проверенных чатов</DetailTitle>
                      <div style={{ 
                        width: '100%', 
                        height: '400px',
                        background: switcher ? '#2d2d2d' : '#ffffff',
                        padding: '10px',
                        borderRadius: '8px',
                        border: `1px solid ${switcher ? '#525252' : '#e5e7eb'}`
                      }}>
                        <ResponsiveContainer width="100%" height="100%">
                          <AreaChart
                            data={groupDetails.daily_statistics}
                            margin={{
                              top: 20,
                              right: 20,
                              left: 40,
                              bottom: 30,
                            }}
                          >
                            <CartesianGrid 
                              strokeDasharray="3 3" 
                              stroke={switcher ? '#525252' : '#e5e7eb'}
                            />
                            <XAxis 
                              dataKey="day"
                              stroke={switcher ? '#9ca3af' : '#6b7280'}
                              tick={{ fill: switcher ? '#9ca3af' : '#6b7280', fontSize: 12 }}
                              tickMargin={10}
                              label={{ 
                                value: 'День месяца', 
                                position: 'insideBottom', 
                                offset: -15,
                                fill: switcher ? '#9ca3af' : '#6b7280',
                                fontSize: 12
                              }}
                              interval="preserveStartEnd"
                            />
                            <YAxis 
                              stroke={switcher ? '#9ca3af' : '#6b7280'}
                              tick={{ fill: switcher ? '#9ca3af' : '#6b7280', fontSize: 12 }}
                              tickMargin={10}
                              label={{ 
                                value: 'Проверено чатов', 
                                angle: -90, 
                                position: 'insideLeft',
                                fill: switcher ? '#9ca3af' : '#6b7280',
                                fontSize: 12,
                                offset: -25
                              }}
                              width={35}
                            />
                            <Tooltip
                              contentStyle={{
                                backgroundColor: switcher ? '#374151' : '#ffffff',
                                border: `1px solid ${switcher ? '#525252' : '#e5e7eb'}`,
                                borderRadius: '6px',
                                color: switcher ? '#ffffff' : '#000000',
                                fontSize: 12,
                                padding: '8px'
                              }}
                              labelStyle={{
                                color: switcher ? '#ffffff' : '#000000',
                                fontWeight: 'bold',
                                marginBottom: '5px'
                              }}
                              formatter={(value) => [`${value} чатов`, 'Проверено']}
                              labelFormatter={(day) => `День ${day}`}
                            />
                            <Area
                              type="monotone"
                              dataKey="total_checked_chats_per_day"
                              name="Проверено чатов"
                              stroke="#3b82f6"
                              fill="#3b82f6"
                              fillOpacity={0.3}
                              strokeWidth={2}
                            />
                          </AreaChart>
                        </ResponsiveContainer>
                      </div>
                    </DetailSection>
                  )}

                </GroupDetailsContainer>
              ) : (
                <div style={{ textAlign: 'center', padding: '20px', color: switcher ? '#9ca3af' : '#6b7280' }}>
                  Детали группы не найдены
                </div>
              )}
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      )}

      {/* Второе модальное окно для добавления агентов */}
      {isAddAgentsModalOpen && (
        <SecondModalOverlay onClick={handleCloseAddAgentsModal}>
          <SecondModalContent switcher={switcher} onClick={(e) => e.stopPropagation()}>
            <ModalHeader switcher={switcher}>
              <ModalTitle switcher={switcher}>Добавить агентов в группу</ModalTitle>
              <CloseButton switcher={switcher} onClick={handleCloseAddAgentsModal}>
                ✕
              </CloseButton>
            </ModalHeader>
            
            <SearchSection switcher={switcher}>
              <SearchTitle switcher={switcher}>Поиск свободных агентов</SearchTitle>
              <SearchForm>
                <SearchInput
                  type="text"
                  placeholder="LCID"
                  value={searchLcid}
                  onChange={(e) => setSearchLcid(e.target.value)}
                  switcher={switcher}
                />
                <SearchInput
                  type="text"
                  placeholder="Имя агента"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  switcher={switcher}
                />
                <SearchInput
                  type="text"
                  placeholder="Год-месяц (YYYY-MM)"
                  value={searchYearMonth}
                  onChange={(e) => setSearchYearMonth(e.target.value)}
                  switcher={switcher}
                />
                <SearchButton onClick={handleSearchAgents} disabled={loading}>
                  Поиск
                </SearchButton>
              </SearchForm>
              {/* Кнопка добавить всех */}
              {(userType === 'head' || userType === 'tl') && freeAgents && Array.isArray(freeAgents) && freeAgents.length > 0 && (
                <AddAgentButton
                  style={{ marginTop: 12, width: '100%' }}
                  onClick={async () => {
                    for (const agent of freeAgents) {
                      await handleAddAgentToGroup(agent.id);
                    }
                  }}
                >
                  Добавить всех
                </AddAgentButton>
              )}
            </SearchSection>

            <AgentsListSection switcher={switcher}>
              {loading ? (
                <LoadingContainer>
                  <LoadingText switcher={switcher}>Загрузка агентов...</LoadingText>
                </LoadingContainer>
              ) : freeAgents && Array.isArray(freeAgents) && freeAgents.length > 0 ? (
                freeAgents.map((agent) => (
                  <AgentItem key={agent.id} switcher={switcher}>
                    <AgentInfo>
                      <AgentName switcher={switcher}>{agent.name}</AgentName>
                      <AgentLcid switcher={switcher}>{agent.lcid}</AgentLcid>
                      {agent.chat_count !== undefined && (
                        <div style={{ 
                          fontSize: '12px', 
                          color: switcher ? '#9ca3af' : '#6b7280',
                          marginTop: '2px'
                        }}>
                          Чатов: {agent.chat_count}
                        </div>
                      )}
                    </AgentInfo>
                    <AddAgentButton onClick={() => handleAddAgentToGroup(agent.id)}>
                      Добавить
                    </AddAgentButton>
                  </AgentItem>
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '20px', color: switcher ? '#9ca3af' : '#6b7280' }}>
                  Свободные агенты не найдены
                </div>
              )}
            </AgentsListSection>
          </SecondModalContent>
        </SecondModalOverlay>
      )}

      {/* Модальное окно создания группы */}
      {isCreateGroupModalOpen && (
        <ModalOverlay onClick={handleCloseCreateGroupModal}>
          <ModalContent switcher={switcher} onClick={(e) => e.stopPropagation()}>
            <ModalHeader switcher={switcher}>
              <ModalTitle switcher={switcher}>Создать новую группу</ModalTitle>
              <CloseButton switcher={switcher} onClick={handleCloseCreateGroupModal}>
                ✕
              </CloseButton>
            </ModalHeader>
            
            <ModalBody switcher={switcher}>
              <CreateGroupForm>
                <FormField>
                  <FormLabel switcher={switcher}>Название группы *</FormLabel>
                  <FormInput
                    type="text"
                    placeholder="Введите название группы"
                    value={newGroupData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    switcher={switcher}
                  />
                </FormField>

                <FormRow>
                  <FormField>
                    <FormLabel switcher={switcher}>Руководитель</FormLabel>
                    <Select
                      value={newGroupData.head}
                      onChange={(e) => handleInputChange('head', parseInt(e.target.value) || 0)}
                      switcher={switcher}
                    >
                      <option value="">Выберите руководителя</option>
                      {groupHeads && Array.isArray(groupHeads) && groupHeads.map((head) => (
                        <option key={head.id} value={head.id}>
                          {head.username} ({head.type})
                        </option>
                      ))}
                    </Select>
                  </FormField>
                  <FormField>
                    <FormLabel switcher={switcher}>Год</FormLabel>
                    <FormInput
                      type="number"
                      placeholder="2025"
                      value={newGroupData.year}
                      onChange={(e) => handleInputChange('year', parseInt(e.target.value) || 2025)}
                      switcher={switcher}
                    />
                  </FormField>
                </FormRow>

                <FormRow>
                  <FormField>
                    <FormLabel switcher={switcher}>Месяц</FormLabel>
                    <FormInput
                      type="number"
                      placeholder="7"
                      min="1"
                      max="12"
                      value={newGroupData.month}
                      onChange={(e) => handleInputChange('month', parseInt(e.target.value) || 7)}
                      switcher={switcher}
                    />
                  </FormField>
                  <FormField>
                    <FormLabel switcher={switcher}>Агенты (ID через запятую)</FormLabel>
                    <FormInput
                      type="text"
                      placeholder="1, 2, 3"
                      value={newGroupData.agents.join(', ')}
                      onChange={(e) => {
                        const agents = e.target.value
                          .split(',')
                          .map(id => parseInt(id.trim()))
                          .filter(id => !isNaN(id));
                        handleInputChange('agents', agents);
                      }}
                      switcher={switcher}
                    />
                  </FormField>
                </FormRow>

                <FormField>
                  <FormLabel switcher={switcher}>Комментарий</FormLabel>
                  <FormTextarea
                    placeholder="Введите комментарий к группе"
                    value={newGroupData.comment}
                    onChange={(e) => handleInputChange('comment', e.target.value)}
                    switcher={switcher}
                  />
                </FormField>

                <FormActions>
                  <CancelButton switcher={switcher} onClick={handleCloseCreateGroupModal}>
                    Отмена
                  </CancelButton>
                  <SubmitButton 
                    onClick={handleCreateGroup}
                    disabled={!newGroupData.name.trim() || loading}
                  >
                    Создать группу
                  </SubmitButton>
                </FormActions>
              </CreateGroupForm>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      )}

      {/* Модальное окно редактирования группы */}
      {isEditGroupModalOpen && (
        <ModalOverlay onClick={handleCloseEditGroupModal}>
          <ModalContent switcher={switcher} onClick={(e) => e.stopPropagation()}>
            <ModalHeader switcher={switcher}>
              <ModalTitle switcher={switcher}>Редактировать группу</ModalTitle>
              <CloseButton switcher={switcher} onClick={handleCloseEditGroupModal}>
                ✕
              </CloseButton>
            </ModalHeader>
            
            <ModalBody switcher={switcher}>
              <CreateGroupForm>
                <FormField>
                  <FormLabel switcher={switcher}>Название группы *</FormLabel>
                  <FormInput
                    type="text"
                    placeholder="Введите название группы"
                    value={editGroupData.name}
                    onChange={(e) => handleEditInputChange('name', e.target.value)}
                    switcher={switcher}
                  />
                </FormField>

                <FormRow>
                  <FormField>
                    <FormLabel switcher={switcher}>Руководитель</FormLabel>
                    <Select
                      value={editGroupData.head}
                      onChange={(e) => handleEditInputChange('head', parseInt(e.target.value) || 0)}
                      switcher={switcher}
                    >
                      <option value="">Выберите руководителя</option>
                      {groupHeads && Array.isArray(groupHeads) && groupHeads.map((head) => (
                        <option key={head.id} value={head.id}>
                          {head.username} ({head.type})
                        </option>
                      ))}
                      {/* Показываем текущего руководителя, если его нет в списке */}
                      {editGroupData.head && groupHeads && Array.isArray(groupHeads) && 
                       !groupHeads.find(head => head.id === editGroupData.head) && (
                        <option value={editGroupData.head} disabled>
                          Текущий руководитель (не найден в списке)
                        </option>
                      )}
                    </Select>
                  </FormField>
                  <FormField>
                    <FormLabel switcher={switcher}>Год</FormLabel>
                    <FormInput
                      type="number"
                      placeholder="2025"
                      value={editGroupData.year}
                      onChange={(e) => handleEditInputChange('year', parseInt(e.target.value) || 2025)}
                      switcher={switcher}
                    />
                  </FormField>
                </FormRow>

                <FormRow>
                  <FormField>
                    <FormLabel switcher={switcher}>Месяц</FormLabel>
                    <FormInput
                      type="number"
                      placeholder="7"
                      min="1"
                      max="12"
                      value={editGroupData.month}
                      onChange={(e) => handleEditInputChange('month', parseInt(e.target.value) || 7)}
                      switcher={switcher}
                    />
                  </FormField>
                </FormRow>

                <FormField>
                  <FormLabel switcher={switcher}>Комментарий</FormLabel>
                  <FormTextarea
                    placeholder="Введите комментарий к группе"
                    value={editGroupData.comment}
                    onChange={(e) => handleEditInputChange('comment', e.target.value)}
                    switcher={switcher}
                  />
                </FormField>

                <FormActions>
                  <CancelButton switcher={switcher} onClick={handleCloseEditGroupModal}>
                    Отмена
                  </CancelButton>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      type="button"
                      onClick={handleDeleteGroup}
                      disabled={loading}
                      style={{
                        padding: '8px 16px',
                        fontSize: '14px',
                        background: loading ? '#9ca3af' : '#ef4444',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        transition: 'background 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        if (!loading) {
                          e.target.style.background = '#dc2626';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!loading) {
                          e.target.style.background = '#ef4444';
                        }
                      }}
                    >
                      Удалить группу
                    </button>
                    <SubmitButton 
                      onClick={handleEditGroup}
                      disabled={!editGroupData.name.trim() || loading}
                    >
                      Сохранить изменения
                    </SubmitButton>
                  </div>
                </FormActions>
              </CreateGroupForm>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      )}
    </Container>
  );
};

export default QaGroup;